import { Injectable } from "@angular/core";
import { Accounts, BillerInterface } from "@tae/interfaces";
import { PictureBasicCardEnum } from "src/app/enums/basic-card.enum";
import { billersFixture } from "src/app/fixtures/billers.fixture";
import { PictureBasicCardInterface } from "src/app/interfaces/basic-card.interface";
import {
  CardaNativeInterface,
  RechargeInterface,
} from "src/app/interfaces/ctrl-recharge.interface";
import { RechargeHistoryInterface } from "src/app/interfaces/recharge-history.interface";
import { RechageType } from "src/app/types/recharge-history.type";

@Injectable({
  providedIn: "root",
})
export class CtrlRechargeService {
  /* Almacena el valor el importe ingresado por el cliente */
  private _amount: number;
  /* Almacena el valor del numero celular ingresado por el cliente*/
  private _phone: string;
  /* Almacena el valor del biller seleccionado ne el carousel*/
  private _biller: BillerInterface;
  /* account selected */
  private _accountSelected: Accounts;
  /* billers */
  private _billers: BillerInterface[];

  private _product: string;
  /**
   * Almacena las tarjetas recibidas por el callback retrieveCards
   */
  private _cardsData: CardaNativeInterface[];

  private _textTokens: any;
  /* accounts */
  private _accounts: Accounts[];

  private _recharegesHistory: RechargeHistoryInterface[];

  showDirectory = false;

  public set amount(_value: number) {
    this._amount = _value;
  }

  public set phone(_value: string) {
    this._phone = _value;
  }

  public set biller(_value: BillerInterface) {
    this._biller = _value;
  }

  public set billers(_value: BillerInterface[]) {
    this._amount = undefined;
    this._billers = _value;
  }

  public set accountSelected(_value: Accounts) {
    this._accountSelected = _value;
  }

  public set cardsData(_value: CardaNativeInterface[]) {
    this._cardsData = _value;
  }

  public set textTokens(_value: any) {
    this._textTokens = _value;
  }

  public set accounts(_value: Accounts[]) {
    this._accounts = _value;
  }

  public set recharegesHistory(_value: RechargeHistoryInterface[]) {
    this._recharegesHistory = _value;
  }

  public set product(_value: string) {
    this._product = _value;
  }

  public get billers(): BillerInterface[] {
    return this._billers;
  }

  public get recharge(): RechargeInterface | undefined {
    return {
      amount: this._amount,
      phone: this._phone,
      biller: this._biller,
      accountSelected: this._accountSelected,
      product: this._product,
    };
  }

  public get cardsData(): CardaNativeInterface[] {
    return this._cardsData;
  }

  public get textTokens(): any {
    return this._textTokens;
  }

  public get accounts(): Accounts[] {
    return this.setCardImage();
  }

  public get recharegesHistory(): RechageType[] {
    if (!this._recharegesHistory?.length || !this.billers?.length) return [];
    return [...this._recharegesHistory].map((_item) => {
      const find = this.billers.find(
        (_element) => _element.billerId === _item.carrierId
      );
      return { ..._item, ...find };
    });
  }

  public resetRecharge(): void {
    this._amount = undefined;
    this._accountSelected = undefined;
    this._biller = undefined;
    this._phone = undefined;
    this._product = undefined;
  }

  /**
   * Invalida el caché de cuentas e historial para forzar una nueva
   * consulta a catálogos en la siguiente carga del historial.
   */
  public invalidateHistoryCache(): void {
    this._accounts = undefined;
    this._recharegesHistory = undefined;
  }

  /**
   * Invalida solo el historial de recargas, manteniendo las cuentas en cache.
   * Útil después de crear una recarga programada para refrescar el historial
   * sin perder el cache de cuentas (evita error GOTA03).
   */
  public invalidateRechargesOnly(): void {
    this._recharegesHistory = undefined;
  }

  /**
   * Agrega una nueva recarga al historial en memoria.
   * Esto evita tener que llamar a /SSO/validate para actualizar el historial.
   */
  public addRechargeToHistory(recharge: RechargeHistoryInterface): void {
    //console.log('addRechargeToHistory - before:', this._recharegesHistory?.length, 'adding:', recharge);
    if (!this._recharegesHistory) {
      this._recharegesHistory = [];
    }
    // Agregar al inicio del array para que aparezca primero (más reciente)
    this._recharegesHistory = [recharge, ...this._recharegesHistory];
    //console.log('addRechargeToHistory - after:', this._recharegesHistory?.length, this._recharegesHistory);
  }

  private setCardImage(): Accounts[] {
    return this._accounts?.map((account) => {
      const find = this._cardsData?.find(
        (card) => card.cardNumber === account.card.cardNumber
      );
      return { ...account, imageCode: find?.imageCode };
    });
  }

  getPicture(_id: string): PictureBasicCardInterface {
    const find = this._billers.find(_item => _item.billerId === _id);
    const logo = find?.urlBillerLogo || billersFixture.get(_id) || '';
    const type = logo ? PictureBasicCardEnum.img : PictureBasicCardEnum.icon;
    return { value: logo || 'mobile', type };
  }
}
